import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const termsContent = `
Última actualización: Febrero 2026

1. Aceptación de los Términos
Al adquirir y utilizar "IA Sin Miedo (48 horas)", aceptas estos términos y condiciones en su totalidad.

2. Producto Digital
"IA Sin Miedo (48 horas)" es un producto digital (PDF) de descarga inmediata. Una vez completada la compra, recibirás acceso al material de forma permanente.

3. Uso Personal
La guía es para uso personal y de tu negocio. No está permitida la redistribución, reventa, ni compartir el contenido con terceros sin autorización expresa.

4. Propiedad Intelectual
Todo el contenido de la guía —textos, plantillas, prompts y estructura— es propiedad intelectual del autor. Queda prohibida su reproducción total o parcial sin consentimiento.

5. Política de Reembolso
Debido a la naturaleza digital del producto, no se ofrecen reembolsos una vez realizada la descarga. Si tienes problemas técnicos con la entrega, contáctanos y lo resolveremos.

6. Limitación de Responsabilidad
Los resultados obtenidos con la guía dependen del uso individual. No garantizamos resultados específicos de negocio. El contenido es educativo y orientativo.

7. Modificaciones
Nos reservamos el derecho de actualizar estos términos. Los cambios serán efectivos desde su publicación.
`.trim();
const privacyContent = `
Última actualización: Febrero 2026

1. Información que Recopilamos
Al realizar tu compra, recopilamos únicamente: nombre, correo electrónico y datos de pago procesados por la plataforma de cobro (no almacenamos datos de tarjeta).

2. Uso de la Información
Tu información se utiliza exclusivamente para:
• Entregar el producto digital adquirido
• Enviar comunicaciones relacionadas con tu compra
• Mejorar nuestros productos y servicios

3. Protección de Datos
Implementamos medidas de seguridad para proteger tu información personal. No vendemos, intercambiamos ni transferimos tus datos a terceros.

4. Correos Electrónicos
Podrás recibir correos relacionados con tu compra y contenido de valor. Puedes darte de baja en cualquier momento usando el enlace al final de cada correo.

5. Cookies
Nuestro sitio puede utilizar cookies para mejorar la experiencia. Puedes desactivarlas en la configuración de tu navegador.

6. Derechos del Usuario
Tienes derecho a solicitar acceso, corrección o eliminación de tus datos personales en cualquier momento.

7. Contacto
Para cualquier consulta sobre privacidad, puedes comunicarte a través de los canales indicados en la plataforma de venta.
`.trim();
function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
}) {
  return <AnimatePresence data-id="element-41">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-42">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-43" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="relative bg-[#FDF8F3] rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden border border-stone-200" data-id="element-44">
            <div className="flex items-center justify-between p-6 border-b border-stone-200" data-id="element-45">
              <h2 className="text-xl font-bold text-stone-900" data-id="element-46">{title}</h2>
              <button onClick={onClose} className="text-stone-400 hover:text-stone-700 transition-colors p-1 rounded-lg hover:bg-stone-100" data-id="element-47">
                <XIcon className="h-5 w-5" data-id="element-48" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-49">
              <div className="prose prose-stone prose-sm max-w-none" data-id="element-50">
                {content.split('\n\n').map((paragraph, i) => <p key={i} className="text-stone-600 leading-relaxed mb-4 whitespace-pre-line text-sm" data-id="element-51">
                    {paragraph}
                  </p>)}
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  return <>
      <footer className="bg-stone-900 text-stone-400 py-12 pb-24 px-4 border-t border-stone-800" data-id="element-52">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-53">
          <div className="text-sm" data-id="element-54">
            © {new Date().getFullYear()} IA Sin Miedo. Todos los derechos
            reservados.
          </div>
          <div className="flex gap-6 text-sm" data-id="element-55">
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors" data-id="element-56">
              Términos
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors" data-id="element-57">
              Privacidad
            </button>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" content={termsContent} data-id="element-58" />
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" content={privacyContent} data-id="element-59" />
    </>;
}